import React, { ComponentProps } from "react";
import { CpIconDynamic } from "../../cp-icon/cp-icon.component";
import { RenderIconDynamic } from "../../cp-icon/render-icon-dynamic";
import { CpBadgeProps } from "../cp-badge";
import { tw } from "src/utils";

type BadgeContentProps = {
  iconLeft?: CpIconDynamic;
  iconRight?: CpIconDynamic;
  iconOnly?: CpIconDynamic;
  size?: CpBadgeProps["size"];
} & ComponentProps<"div">;

export const CpBadgeContent = ({
  children,
  iconLeft,
  iconRight,
  iconOnly,
  size = "md",
}: BadgeContentProps) => {
  const iconSize = size === "sm" ? "!size-3 !min-w-3" : "!size-4 !min-w-4";

  if (iconOnly) {
    return <RenderIconDynamic icon={iconOnly} className={tw(iconSize)} />;
  }

  return (
    <div
      className={tw(
        "inline-flex items-center gap-1 align-middle justify-center",
      )}
    >
      {iconLeft && (
        <RenderIconDynamic icon={iconLeft} className={tw(iconSize)} />
      )}
      <span>{children}</span>
      {iconRight && (
        <RenderIconDynamic icon={iconRight} className={tw(iconSize)} />
      )}
    </div>
  );
};
